import { useSelector } from 'react-redux';
import { Component as ComponentContainer } from '@styles/layout';
import { getRecentlyViewed, RecentlyViewedItem } from '@state/slices/recently-viewed';
import { RecentlyViewed } from '@components/recently-viewed';

export const RecentlyViewedContainer = () => {
  const recentlyViewed: Array<RecentlyViewedItem> = useSelector(getRecentlyViewed);
  return (
    <ComponentContainer>
      <RecentlyViewed title={'recently-viewed__header--label'} recentlyViewed={recentlyViewed} />
    </ComponentContainer>
  );
};
